import PropTypes from "prop-types";
import styled from "styled-components";

import GroupLabel from "./GroupLabel";
import GroupListItem from "./GroupListItem";
import Icon from "./Icon";

const AddIcon = styled(Icon)`
    margin-right: 0.5em;
`;

/**
 * List item button with a plus icon for adding a new group.
 *
 * @param root0 - The component props.
 * @param root0.onAdd - Callback when the add button is clicked.
 * @returns The rendered add list item.
 */
const ListItemAdd = ({ onAdd }) => (
    <GroupListItem pointer changeColorOnHover key="new" onClick={onAdd}>
        <GroupLabel>
            <AddIcon className="fa fa-plus" /> Add
        </GroupLabel>
    </GroupListItem>
);

ListItemAdd.propTypes = {
    onAdd: PropTypes.func.isRequired,
};

export default ListItemAdd;
